<template>
  <div class="ui-star-rating">
    <div class="ui-star-rating__wrapper">
      <img
        src="/images/icons/ui-star-rating-star.svg"
        width="45"
        height="43"
        alt=""
        class="ui-star-rating__img">

      <span class="ui-star-rating__count">
        {{ rating }}
      </span>
    </div>

    <div class="ui-star-rating__orders">
      <h2 class="ui-star-rating__title">
        Rated {{ rating }}
      </h2>
      <p class="ui-star-rating__subtitle">
        based on <span class="ui-star-rating__orders-count">{{ ordersCount }} orders</span> completed this month
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'UiStarRating',

  props: {
    rating: {
      type: Number,
      required: true,
    },

    ordersCount: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .ui-star-rating {
    display: grid;
    grid-column-gap: 8px;
    grid-template-columns: max-content 1fr;
    align-items: center;
    line-height: 1.2;
  }

  .ui-star-rating__wrapper {
    position: relative;
    display: inline-flex;

    &:after, &:before {
      --animation-pulse-scale: 1.6;

      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      transform: translate(-50%, -50%) scale(1);
      top: 48%;
      left: 50%;
      background: url(/images/icons/ui-star-rating-star.svg) no-repeat 50% 50%;
      background-size: 100%;
    }

    &:before {
      animation: pulse 5s infinite ease-out;
    }

    &:after {
      animation: pulse 5s infinite .75s ease-out;
    }
  }

  .ui-star-rating__count {
    position: absolute;
    top: 54%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: 500;
    font-size: 15px;
  }

  .ui-star-rating__orders {
    font-weight: 500;
    font-size: 11px;
  }

  .ui-star-rating__title {
    font-weight: 500;
    font-size: 15px;
  }

  .ui-star-rating__subtitle {
    margin-top: 4px;
    font-weight: 300;
    font-size: 13px;
  }

  .ui-star-rating__orders-count {
    font-weight: 500;
    color: $color--basic-green;
  }

  @media screen and #{$screen-more-or-1280} {
    .ui-star-rating {
      grid-column-gap: 16px;
    }

    .ui-star-rating__img {
      width: 60px;
      height: 57px;
    }

    .ui-star-rating__count {
      font-size: 19px;
    }

    .ui-star-rating__orders {
      font-size: 13px;
    }
  }
</style>
